import { IP_BLOCK } from "@/constants/error";
import useAuthStore from "@/stores/useAuthStore";
import useLayoutStore, { banUserByIp, unBanUserByIp } from "@/stores/useLayoutStore";
import type ApiResponseType from "@/utils/types/ApiResponseType";
import type { FetchLike, WretchOptions } from "wretch";

const authTokenMiddleware = (next: FetchLike) => async (url: string, opts: WretchOptions) => {
  const authToken = useAuthStore.getState().token || "";

  if (authToken) {
    opts.headers = {
      ...opts.headers,
      Token: authToken,
    };

    unBanUserByIp();
  }

  const res = await next(url, opts);

  const clone = res.clone();
  const isSuccess = clone.status >= 200 && clone.status < 300;
  if (isSuccess) {
    const json = (await clone.json()) as ApiResponseType;
    if (json.Message === IP_BLOCK) {
      banUserByIp();
    }
  }

  if (res.headers.has("x-token-expired") || res.status === 403) {
    useAuthStore.getState().clearAuth();
    useLayoutStore.getState().setShouldSignOut(true);
  }

  return res;
};

export default authTokenMiddleware;
